import { MutationTree } from 'vuex'
import { Item, ModuleState } from './types'
import { initialState } from './index'

export const mutations: MutationTree<ModuleState> = {
  handleResponse(state, payload: { items: Item[] }) {
    state.items = payload.items;
  },
  reset(state) { Object.assign(state, initialState) },
};
